module.exports = __webpack_public_path__ + "static/media/3S.1da91887.svg";